import React from 'react';
import { CancellationSurveyModalProps } from '../../types/cancellation';
import { useCancellationSurveyModal } from '../../hooks/useCancellationSurveyModal';
import { CancellationQuestion } from './CancellationQuestion';
import { CancellationModalWrapper } from './CancellationModalWrapper';
import { StanButton } from '@/components';

export const CancellationSurveyModal = ({ isOpen, onClose, onComplete }: CancellationSurveyModalProps) => {
    const {
        currentQuestion,
        currentAnswer,
        canSkip,
        isCurrentAnswerValid,
        isFirstQuestion,
        isSurveyComplete,
        showNextButton,
        handleClose,
        handleSkip,
        handleBack,
        handleNext,
        handleAnswerWithNavigation,
    } = useCancellationSurveyModal({ isOpen, onClose, onComplete });

    if (!currentQuestion) {
        return null;
    }

    return (
        <CancellationModalWrapper isOpen={isOpen} onClose={handleClose}>
            {/* Question */}
            <CancellationQuestion
                question={currentQuestion}
                answer={currentAnswer}
                onAnswer={handleAnswerWithNavigation}
            />

            {/* Navigation Buttons */}
            <div className='mt-8 space-y-4'>
                {/* Back/Next Buttons */}
                {(!isFirstQuestion || showNextButton) && (
                    <div className='flex gap-4'>
                        {!isFirstQuestion && (
                            <StanButton
                                name='cancellation-survey-back'
                                variant='outline'
                                onClick={handleBack}
                                className={showNextButton ? 'flex-1' : 'w-full'}
                            >
                                Back
                            </StanButton>
                        )}
                        {showNextButton && (
                            <StanButton
                                name='cancellation-survey-next'
                                disabled={!isCurrentAnswerValid}
                                onClick={handleNext}
                                className='flex-1'
                            >
                                {isSurveyComplete ? 'Submit' : 'Next'}
                            </StanButton>
                        )}
                    </div>
                )}

                {/* Skip Button */}
                {canSkip && (
                    <StanButton
                        name='skip-feedback-cancellation-modal'
                        variant='ghost'
                        onClick={handleSkip}
                        className='w-full'
                    >
                        Skip feedback
                    </StanButton>
                )}
            </div>
        </CancellationModalWrapper>
    );
};
